import { useQuery } from "@apollo/client";
import { Card, Col, Row } from "react-bootstrap";

import BotTable from "./components/BotTable";
import { GET_BOT_LIST } from "../../graphql/queries/management";

const Bot = () => {
  const { data: { getBotList } = {} } = useQuery(GET_BOT_LIST);

  return (
    <>
      <Row className="lao">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>
                <h3 className="p-1">ຈັດການຂໍ້ມູນບັອດ</h3>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <BotTable data={getBotList} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Bot;
